// Lazily loads an article body in the SPA so each post only downloads its own HTML.
// Loaded bodies are cached so a pre-built post can hydrate with its body already present:
// preloadRoute() awaits the body before rendering on the server and before hydrating in the browser.

const bodies = import.meta.glob<{ default: string }>('../content/blog/html/*.ts');
const loaded = new Map<string, string>();

export async function loadPostContent(slug: string): Promise<string | undefined> {
  const cached = loaded.get(slug);
  if (cached !== undefined) return cached;
  const load = bodies[`../content/blog/html/${slug}.ts`];
  if (!load) return undefined;
  const html = (await load()).default;
  loaded.set(slug, html);
  return html;
}

/** The body for `slug` if it has already been loaded, without waiting. */
export const getLoadedPostContent = (slug: string) => loaded.get(slug);
